<template>
	<div id="app">
		<van-nav-bar title="志愿世界" left-text="" right-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
			<van-icon name="wap-home" slot="right" />
		</van-nav-bar>
		<keep-alive :include='includedComponents' exclude=''>
			<router-view >
				<!-- 这里是会被缓存的视图组件 -->
			</router-view>
		</keep-alive>
		<van-tabbar v-model="active" v-show="tabbarShow">
			<van-tabbar-item icon="home-o"  @click="go('/home')">
				首页
			</van-tabbar-item>
			<van-tabbar-item icon="chat-o" @click="go('/message')">
				消息
			</van-tabbar-item>
			<van-tabbar-item icon="friends-o" @click="go('/user')" active-color="red">
				<span>个人中心</span>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>
<script>
	import store from '@/store/store.js';
	import global from '@/api/global';
	import { NavBar, Popup, Tabbar, TabbarItem,Icon } from 'vant';
	export default {
		watch: {
			'$store.state.includedComponents': function() {
				this.includedComponents = this.$store.state.includedComponents;
				//你需要执行的代码
			},
			//底部导航栏的显示
			$route(to, from) {
				this.includedComponents = this.$store.state.includedComponents;
				for(var i = 0; i < this.tabbarMap.length; i++) {
					if(this.tabbarMap[i] == to.path) {
						this.active = i;
						break;
					}
				}
				for(var i = 0; i < this.tabbarList.length; i++) {
					if(to.path == this.tabbarList[i]) {
						this.tabbarShow = true;
						document.body.style.marginBottom = "50px";
						break;
					} else {
						this.tabbarShow = false;
						document.body.style.marginBottom = "0px";
					}
				}
				this.show = false;
			}
		},
		components: {
			[NavBar.name]: NavBar,
			[Popup.name]: Popup,
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
			[Icon.name]:Icon
		},
		data() {
			return {
				includedComponents: "",
				tabbarMap: [
					'/home',
					'/message',
					'/user'
				],
				tabbarList: ['/home', '/message', '/user'], //显示底部导航栏的路由
				tabbarShow: true, //底部导航栏显示
				show: false, //右上角下拉列表显示
				active: 0,
				icon: {
					normal: 'https://img.yzcdn.cn/public_files/2017/10/13/c547715be149dd3faa817e4a948b40c4.png',
					active: 'https://img.yzcdn.cn/public_files/2017/10/13/793c77793db8641c4c325b7f25bf130d.png'
				}
			};
		},
		created: function() {
			if(this.$route.query.active != null) {
				this.active = this.$route.query.active;
			}
		},
		methods: {
			onClickRight() {
    		 	this.$router.push({
					path: '/home'
				});
  			},
			go(p) {
				this.$router.push({
					path: p
				});
			},
			onClickLeft() {
				this.$router.back();
			}
		}
	}
</script>

<style>
	.van-tabbar-item--active {
		color: #ff4500;
	}
	#app .van-nav-bar__title {
		color: white;
	}

	#app .van-hairline--bottom::after {
		border-bottom-width: 0px;
	}

	#app a {
		color: #7d7e80;
	}

	#app a:active {
		color: #1989fa;
	}

	#app a:hover {
		color: #1989fa;
	}

	#app .van-hairline--top-bottom {
		z-index: 999 !important;
	}


	#app .pop_span {
		margin: 8px;
	}

	#app .pop {
		height: 40px;
		margin: 0px;
		background-color: #137ac3;
		color: white;
		border-top: 1px solid #81b4db;
	}

	#app .van-popup {
		top: 46px;
	}

	body {
		font-size: 16px;
		background-color: #f8f8f8;
		-webkit-font-smoothing: antialiased;
	}

	#app .van-hairline--bottom {
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-color: orangered;
	}

	.van-nav-bar .van-icon {
		color: white;
	}

	.van-nav-bar__text {
		color: white;
	}
</style>
